import React from 'react';

export const BlobView = () => {
    return (
        <div style={{ padding: 24 }}>
            <h2 style={{ marginBottom: 12 }}>Blob explorer</h2>
            <p>
                The direct Azure browser SDK demo has been disabled in this build because the
                current frontend bundle cannot safely resolve the Node-oriented Azure identity
                modules.
            </p>
            <p style={{ marginTop: 12 }}>
                If you need blob browsing here, wire it through a backend API or use a browser-
                compatible authentication flow that is bundled separately from the main app.
            </p>
        </div>
    );
};